<template>
    <transition
            v-if="isShow && msgList  != null && msgList.length > 0"
            name="custom-classes-transition"
            enter-active-class="animated bounceInRight"
            leave-active-class="animated fadeOutRightBig"
    >
        <div class="msg-dialog">
            <div class="msg-dialog-box">
                <div class="msg-dialog-header">
                    <i class="msg-icon"></i>
                    <span>{{defaultList.topic}}</span>
                    <a class="close" @click="closeMsgDialog"></a>
                </div>
                <div class="msg-dialog-content">
                    <p>
                        <span v-html="subStringHide(defaultList.content)"></span>
                        <a target="_blank" v-if="defaultList.link != null && defaultList.link.length > 0" :href="defaultList.link">查看</a>
                    </p>
                </div>
                <div class="msg-dialog-page">
                    <span class="prev" @click="prevClick"><</span>
                    <span class="page-count">{{currentPage}} / {{totalCount}}</span>
                    <span class="next" @click="nextClick">></span>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import url from '../../../config/url';
    import common from '../../../static/js/common'

    export default {
        data() {
            return {
                isShow: false,
                defaultList: {},
                msgList: [],
                totalCount: 0,
                currentPage: 1
            }
        },
        created: function () {
            var _this = this;
            var timer = setInterval(function () {
                if (window.user_id == undefined) {
                } else {
                    clearInterval(timer);
                    setTimeout(function () {
                        _this.findMessage()
                    }, 2000)
                }
            }, 100);
        },
        mounted: function () {

        },
        methods: {
            prevClick() {
                var _this = this;
                if (_this.currentPage == 1) {
                    return
                } else {
                    _this.currentPage = _this.currentPage - 1;
                    _this.defaultList = _this.msgList[_this.currentPage - 1];
                }
            },
            nextClick() {
                var _this = this;
                if (_this.currentPage == _this.totalCount) {
                    return
                } else {
                    _this.currentPage = _this.currentPage + 1;
                    _this.defaultList = _this.msgList[_this.currentPage - 1];
                }
            },
            subStringHide(str) {
                var str = str.replace(/<a[^>]*>(.*?)<\/a>/g, '');
                var len = 55;
                if(str.length > len){
                    str = str.substring(0,len) + "...";
                }
                return  str;
            },
            closeMsgDialog() {
                this.isShow = false;
            },
            findMessage() {
                if(window.user_id > 0){
                    var _this = this;
                    var params = {
                        userId: window.user_id,
                        isRead: "0",
                    };
                    this.$http.jsonp(url.findMessage, {
                        params: params,
                        'jsonp': 'jsonpCallback'
                    }).then(function (res) {
                        var messageData = res.data;
                        if (messageData != null && messageData.status != "ERROR" && messageData.errorCode != "E017") {
                            if (messageData.result != null && messageData.result.datas != null && messageData.result.datas.length > 0) {
                                _this.isShow = true;
                                _this.msgList = messageData.result.datas;
                                _this.defaultList = _this.msgList[_this.currentPage - 1];
                                _this.totalCount = messageData.result.totalCount;
                            }
                        }
                    }).catch(function () {
                        _this.$Message.error('数据获取失败,请稍后再试!');
                    });
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../static/scss/page/msgDialog";
</style>


// WEBPACK FOOTER //
// src/components/Common/msgDialog.vue